'use client';

import { useEffect } from 'react';
import { PublicHeader as Header } from '@/features/notifications';

interface LandingV2HeaderProps {
    /** 页面拥有会话与活跃时间，Header 只读取动作发生时的公共参数。 */
    getTrackingContext: () => Record<string, unknown> | null;
    /** Whether the hero intro has completed. */
    introComplete: boolean;
    /** 首屏 Header 已开放交互的旁路通知。 */
    onReady?: () => void;
    /** Optional custom class name. */
    className?: string;
}

/**
 * Keeps Landing V2 visual timing while delegating every navigation, dropdown,
 * tracking, pricing and authentication behavior to Enter Home's shared Header.
 */
export function LandingV2Header({ introComplete, className = '', getTrackingContext, onReady }: LandingV2HeaderProps) {
    useEffect(() => {
        if (introComplete) onReady?.();
    }, [introComplete, onReady]);

    return (
        <Header
            className={`landing-v2-header${introComplete ? ' is-visible' : ''} ${className}`}
            allowSigninPopupAutoOpen={introComplete}
            showNotificationBanner={introComplete}
            reserveNotificationBannerSpace
            notificationBannerMode="static"
            enableTextMotion
            trackingSurface="landing_v2"
            getTrackingContext={getTrackingContext}
        />
    );
}
